module.exports = __webpack_public_path__ + "static/media/Kerstkaart2019_heel.90eb1d83.png";